var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65967 12.6094H19.6597",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6597 10.2808V17.4308C19.6297 20.2808 18.8496 21.0008 15.8796 21.0008H6.4397C3.4197 21.0008 2.65967 20.2508 2.65967 17.2708V10.2808C2.65967 7.58078 3.28967 6.71078 5.65967 6.57078C5.89967 6.56078 6.1597 6.55078 6.4397 6.55078H15.8796C18.8996 6.55078 19.6597 7.30078 19.6597 10.2808Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6597 6.73V13.72C22.6597 16.42 22.0297 17.29 19.6597 17.43V10.28C19.6597 7.3 18.8996 6.55 15.8796 6.55H6.4397C6.1597 6.55 5.89967 6.56 5.65967 6.57C5.68967 3.72 6.4697 3 9.4397 3H18.8796C21.8996 3 22.6597 3.75 22.6597 6.73Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90967 17.8105H7.62964",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76965 17.8105H13.2097",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.5406777fabf4c56094842de34c361466.svg";
export { ForwardRef as ReactComponent };